/* milchkindstories: Scroll-Reveals + Warenkorb. Ausfallsicher: Inhalte werden IMMER sichtbar. */
(function(){
  function start(){
    var root=document.querySelector('.mks');
    if(!root) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ziele = [].slice.call(root.querySelectorAll('[data-mks-reveal],.mks-revimg,.mks-line'));
    var listen = [].slice.call(root.querySelectorAll('.mks-list'));

    function zeige(el){ if(el && !el.classList.contains('mks-in')) el.classList.add('mks-in'); }
    function alleZeigen(){ ziele.forEach(zeige); listen.forEach(function(ul){ [].slice.call(ul.querySelectorAll('li')).forEach(zeige); }); }

    if(reduce){ alleZeigen(); return; }
    root.classList.add('mks-js');

    var notbremse = setTimeout(alleZeigen, 1800);

    function pruefen(){
      var h = window.innerHeight || document.documentElement.clientHeight;
      var offen = false;
      ziele.forEach(function(el){
        if(el.classList.contains('mks-in')) return;
        var r = el.getBoundingClientRect();
        if(r.top < h * 0.88 && r.bottom > 0){ zeige(el); } else { offen = true; }
      });
      listen.forEach(function(ul){
        if(ul.dataset.mksDone) return;
        var r = ul.getBoundingClientRect();
        if(r.top < h * 0.88 && r.bottom > 0){
          ul.dataset.mksDone = '1';
          [].slice.call(ul.querySelectorAll('li')).forEach(function(li,i){ setTimeout(function(){ zeige(li); }, i*110); });
        } else { offen = true; }
      });
      if(!offen){ window.removeEventListener('scroll', getaktet); window.removeEventListener('resize', getaktet); }
    }

    var laeuft=false;
    function getaktet(){ if(laeuft) return; laeuft=true; requestAnimationFrame(function(){ pruefen(); laeuft=false; }); }

    window.addEventListener('scroll', getaktet, {passive:true});
    window.addEventListener('resize', getaktet);
    pruefen();
    setTimeout(pruefen, 60);
    setTimeout(pruefen, 400);
    setTimeout(function(){ if(root.querySelector('.mks-in')) clearTimeout(notbremse); }, 500);

    [].slice.call(root.querySelectorAll('form[action*="/cart/add"]')).forEach(function(f){
      f.addEventListener('submit', function(e){
        e.preventDefault();
        var btn=f.querySelector('button[type="submit"]'); if(!btn){ f.submit(); return; }
        var alt=btn.innerHTML; btn.disabled=true; btn.innerHTML='<span>Moment ...</span>';
        fetch('/cart/add.js',{method:'POST',body:new FormData(f)})
          .then(function(r){ return r.json(); })
          .then(function(item){
            if(window.showToast) showToast('„'+item.product_title+'" zum Warenkorb hinzugefügt');
            btn.innerHTML='<span>Hinzugefügt</span>';
            setTimeout(function(){ btn.innerHTML=alt; btn.disabled=false; },2000);
            return fetch('/cart.js');
          })
          .then(function(r){ return r.json(); })
          .then(function(c){ var b=document.getElementById('cart-count'); if(b) b.textContent=c.item_count; })
          .catch(function(){ f.submit(); });
      });
    });

    window.mksGalerie=function(btn, src){
      var main=document.getElementById('mks-gmain-img'); if(!main) return;
      main.style.opacity=0;
      setTimeout(function(){ main.src=src; main.style.opacity=1; },160);
      [].slice.call(document.querySelectorAll('.mks-gthumbs button')).forEach(function(b){ b.classList.remove('sel'); });
      btn.classList.add('sel');
    };
    window.mksMenge=function(d){
      var s=document.getElementById('mks-menge'), i=document.getElementById('mks-menge-input');
      if(!s||!i) return;
      var v=Math.max(1, parseInt(i.value||'1',10)+d);
      i.value=v; s.textContent=v;
    };
    window.mksAkkordeon=function(btn){
      var item=btn.parentElement, body=item.querySelector('.mks-acc-b');
      if(item.classList.contains('open')){ body.style.maxHeight='0px'; item.classList.remove('open'); }
      else { item.classList.add('open'); body.style.maxHeight=body.scrollHeight+'px'; }
    };
    var ersteAcc=root.querySelector('.mks-acc-i.open .mks-acc-b');
    if(ersteAcc) ersteAcc.style.maxHeight=ersteAcc.scrollHeight+'px';
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
